import { Type } from 'class-transformer';
import { KeyValueResultDto } from '../../_models/key-value-result-dto';
import { BlockIssuesResultDto } from './block-issues-result-dto';

export class BuyerOwnerEditorResultDto {
    @Type(() => BlockIssuesResultDto)
    blockIssues: BlockIssuesResultDto[];

    @Type(() => KeyValueResultDto)
    ownerStatuses: KeyValueResultDto[];

    @Type(() => KeyValueResultDto)
    ownerTypes: KeyValueResultDto[];
}
